module.exports = __webpack_public_path__ + "img/user-img.6daa75f1.png";